<template>
  <div class="bg">
    <div class="loginBox">
      <img class="logoImg" src="@/assets/logoImg.png" />
      <span class="helpfulHints">Please choose your Language</span>
      <div class="langBox">
        <div class="languageSelect" @click="showSelect">
          <span class="languageText">{{$t('message.lang')}}</span>
          <img :class="{'dropdownIcon': true, 'reverseDrop': showSel}" src="@/assets/dropdownIcon.svg" />
        </div>
        <div :class="{'langSelBox': true, 'selectBox': showSel, 'notShow': !showSel}">
          <div v-for="(item, index) in languageList" :key="index" @click="selectLanguage(item.value)" class="langItem">{{item.label}}</div>
        </div>
      </div>
      <div class="inputBox">
        <img class="accountIcon" src="@/assets/accountIcon.svg" />
        <div class="input">
          <input class="inputVal" v-model="account" :placeholder="$t('message.accoPlaceholder')" placeholder-class="inputValPlaceholder"/>
        </div>
        <img class="passwordIcon" src="@/assets/passwordIcon.svg" />
        <div class="input">
          <input class="inputVal" v-model="password" :placeholder="$t('message.passPlaceholder')" placeholder-class="inputValPlaceholder" type="password"/>
        </div>
      </div>
      <button class="loginBtn" @click="login">{{$t('message.loginBtnText')}}</button>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/getData.js'
export default {
  name: 'login',
  data () {
    return {
      showSel: false,
      languageList: [{ label: '日本語', value: 'ja' }, { label: '中文', value: 'zh' }, { label: 'English', value: 'en'}],
      account: '',
      password: ''
    }
  },
  created() {
    this.$store.commit('setLang', 'ja')
  },
  methods: {
    showSelect () {
      this.showSel = !this.showSel
    },
    selectLanguage (val) {
      this.showSel = !this.showSel
      this.$store.commit('setLang', val)
    },
    async login () {
      if (!this.account) {
        this.$message(this.$t('message.accoPlaceholder'))
        return
      }
      if (!this.password) {
        this.$message(this.$t('message.passPlaceholder'))
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = { USERNAME: this.account, PASSNAME: this.password }
      let res = await login(param)
      // console.log(res)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
        return
      }
      if (res.data.error !== '0') {
        this.$message.error(res.data.error)
        return
      }
      this.$message({
        message: 'login success',
        type: 'success'
      })
      let JHSS = {
        personalAccount: res.data.ushowname, // 登录账户名
        personalPhone: res.data.phone, // 登录人手机号
        personalUserid: res.data.userid, // 登录人userid
        personalCompany: res.data.guding1, // 登录人公司
        personalSpecial: res.data.TSSF, // 登录人是否具有特殊模板身份
      }
      this.$store.commit('setJHSS', JHSS)
      this.$router.push({ path: '/homePage' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background: url(../assets/loginBgImg.jpg) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.loginBox {
  width: 24.94%;
  /* height: 49.53%; */
  margin-right: 16.6%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  padding: 33px 53px 47px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.logoImg {
  width: 26.09%;
  height: auto;
  background: none;
  margin-bottom: 20px;
}
.helpfulHints {
  display: block;
  width: 100%;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  text-align: left;
}
.langBox {
  width: 100%;
  height: 46px;
  position: relative;
}
.languageSelect {
  width: 100%;
  height: 46px;
  margin-top: 2.5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #E5E5E5;
}
.languageText {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-left: 2px;
}
.dropdownIcon {
  width: 10.5px;
  height: 5.6px;
  margin-right: 7px;
  transition: 1s;
}
.reverseDrop {
  /* transform: rotate(180deg); */
  transform: rotateX(180deg);
  transition: 1s;
}
.langSelBox {
  position: absolute;
  z-index: 100;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 0 0 4px 4px;
  transition: height 1s;
  overflow: hidden;
}
.selectBox {
  height: 138px;
}
.notShow {
  height: 0px;
  border: 0;
  transition: border 1s;
}
.langItem {
  height: 46px;
  font-size: 18px;
  color: #333333;
  line-height: 46px;
  padding: 0 14px;
}
.inputBox {
  width: 100%;
  padding: 30px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.accountIcon {
  width: 17.5px;
  height: 16.7px;
  margin-left: 2.3px;
}
.passwordIcon {
  width: 15.6px;
  height: 19.4px;
  margin-left: 2.3px;
  margin-top: 28px;
}
.input {
  margin-top: 6.5px;
  width: 100%;
  padding: 9px 0;
  border-bottom: 1px solid #E5E5E5;
}
.inputVal {
  width: 100%;
  min-height: 25px;
  font-size: 18px;
  color: #333333;
  text-align: left;
  background: none;
}
.inputValPlaceholder {
  font-size: 18px;
  color: #999999;
}
/* 登录按钮 */
.loginBtn {
  margin-top: 63px;
  width: 100%;
  height: 48px;
  background: #0048FF;
  border-radius: 24px;
  font-size: 18px;
  color: #FFFFFF;
}
</style>
